@if (mohDmsw?.count! > 0) {
  <div id="divChart" class="chart-container">
    <canvas id="admissionsMohDmsw"> </canvas>
  </div>
}
